wbApp.controller('ActivityReconciliationIssuedInvoicesCtrl', ['$scope', '$modal', '$window', 'invoiceSvc',
function ($scope, $modal, $window, invoiceSvc) {

    $scope.semesterID = null;
    $scope.activityID = null;
    $scope.studentID = null;    

    var isActive = false;
    var loaded = false;

    $scope.relatedInvoices = null;

    function loadData(semesterID, activityID, studentID) {
        if (!!activityID && !!studentID) {
            $scope.relatedInvoices = invoiceSvc.getInvoiceEvidenceByActivityAndStudent(activityID, studentID);
        } else {
            $scope.relatedInvoices = null;
        }
    }

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 4) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.activityID && $scope.studentID) {
                    loadData($scope.semesterID, $scope.activityID, $scope.studentID);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.$on('activityStudentSelectionChanged', function (e, data) {
        if (data.studentID != $scope.studentID ||
            data.activityID != $scope.activityID ||
            data.reasonCode == 'activityReconciliationChanged') {
            $scope.semesterID = data.semesterID;
            $scope.activityID = data.activityID;
            $scope.studentID = data.studentID;

            if (isActive) {
                loadData($scope.semesterID, $scope.activityID, $scope.studentID);
                loaded = true;
            } else {
                loaded = false;
            }
        }
    });


    $scope.relatedGridFilterOptions = {
        filterText: ""
    };

    $scope.relatedGridOptions = {
        sortInfo: { fields: ['recordNumber'], directions: ['dsc'] },
        columnDefs: [
            { field: 'isRecurring', displayName: "TXT_LBL_RECURRING", width: '90px', cellFilter: 'checkmark', smHide: true, mdHide: true },
            { field: 'recordNumber', displayName: "TXT_LBL_INVOICE_NO", width: '100px', smHide: true, mdHide: true },
            { field: 'typeID', displayName: "TXT_LBL_TYPE", cellFilter: 'invoiceForType', width: '55px', smHide: true, mdHide: true },
            { field: 'subject', displayName: "TXT_LBL_SUBJECT", sort: 'locale' },
            { field: 'invoiceDate', displayName: "TXT_LBL_INVOICE_DATE", cellFilter: "date:'shortDate'", width: '80px', smHide: true, mdHide: true },
            { field: 'dueDate', displayName: "TXT_LBL_DUE_DATE", cellFilter: "date:'shortDate'", width: '70px' },
            { field: 'total', displayName: "TXT_LBL_AMOUNT", cellFilter: 'wbCurrencyFlt', width: '130px', align: 'right' },
            { field: 'paymentSum', displayName: "TXT_LBL_PAYMENTS_SUM", cellFilter: 'wbCurrencyFlt', width: '130px', align: 'right', smHide: true },
            { field: 'latest', displayName: "TXT_LBL_VALID", cellFilter: 'invoiceValid', width: '90px' }
        ],
        customCmds: [
            {
                text: 'TXT_MENU_PRINT_INVOICE',
                // hide: function () { return true; },
                command: function (row) { onPrintInvoice(row.invoiceID); }
            }],
        disabledField: 'notLatest',
        disabledAreSelectable: true,
        hideDelete: function (row) { return !row.isRecurring; }
    };

    function onPrintInvoice(invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }


    $scope.onRowDelete = function (row) {
        if (row.isRecurring) {
            invoiceSvc.remove(row, function () {
                loadData($scope.semesterID, $scope.activityID, $scope.studentID);
            });
        }
    }

}]);